export enum InputColor{
    ACTIVE_COLOR = "#0fade1",
    DEFAULT_COLOR = "#cccccc",
}